import { encode as base64_encode } from "base-64";
import config from "../config";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";

class DailyJobReportStore {
  loading = false;
  total = 0;
  detailedJobData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      detailedJobData: observable,
      tripData: observable,

      loadData: action,

      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    filterBy,
    driverId,
    status,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      driverId: driverId,
      filterBy: filterBy,
      status: status,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      pageNo: pageNo,
    };


    if(config.pythonReport === 1){
          var response = await postApi.getClient('report').post("/delivery/dailyJobReport", postData);
    }else{
          const base64Input = await base64_encode(JSON.stringify(postData));
          response = await postApi.getClient().post("index.php?c=delivery&a=getDailyJobReport","postData=" + base64Input);
    }

    this.detailedJobData = response?.data?.data?.data;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if(config.pythonReport === 1){    
          try {
              var response = await postApi.getClient("report").post("/delivery/dailyJobReport/download/excel", getData, {
                  responseType: "blob",
              });
          
              const blob = new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
          
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "Daily Job Report.xlsx";
          
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
        
          } catch (error) {
              message.error("Failed to download the report. Please try again.")
          }
    
    }else{
          window.location.href =
            baseURL +
            "index.php?c=delivery&a=exportDailyJobReportExcel&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            "&filterBy=" +
            getData.filterBy +
            "&did=" +
            getData.driverId +
            "&status=" +
            getData.status +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList;
    }
  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("/delivery/dailyjobreport/download/pdf", getData, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Daily Job Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        window.location.href =
          baseURL +
          "index.php?c=delivery&a=exportDailyJobReportPdf&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&filterBy=" +
          getData.filterBy +
          "&did=" +
          getData.driverId +
          "&status=" +
          getData.status +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&userId=" +
          getData.userId +
          "&colList=" +
          getData.colList;
    }
  }
}

export default DailyJobReportStore;
